import { AioExternalReplacements } from "aic";
import { AioExternalReplacementsWithHierarchy } from "contexts/hierarchy/interface";
import { IEditorV3 } from "editor-v3";
import { eHierarchyLevel, eReleaseStatus } from "../../functions/api/enums";

/**
 * Merges the provided external lists with the parent external lists, ensuring no duplicates.
 *
 * @param primaryHierarchyId - The ID of the current hierarchy/node.
 * @param primaryHierarchyLevel - The hierarchy level of the current hierarchy/node.
 * @param releaseStatus - Release status that determines whether lists should be applied.
 * @param lists - External replacement lists defined for this hierarchy level.
 * @param parentLists - Replacement lists inherited from parent hierarchies.
 * @returns The merged set of replacement lists to apply for the current context.
 */
export const getExternalLists = (
  primaryHierarchyId: string,
  primaryHierarchyLevel: eHierarchyLevel,
  releaseStatus: eReleaseStatus,
  lists: AioExternalReplacements<IEditorV3>[],
  parentLists: AioExternalReplacementsWithHierarchy<IEditorV3>[],
): AioExternalReplacementsWithHierarchy<IEditorV3>[] => {
  if (
    [eReleaseStatus.Draft, eReleaseStatus.ReleasePending].includes(releaseStatus) ||
    primaryHierarchyLevel === eHierarchyLevel.Report
  ) {
    const el: AioExternalReplacementsWithHierarchy<IEditorV3>[] = [
      ...parentLists.filter((list) => !lists.some((l) => list.givenName === l.givenName)),
      ...lists.map((list) => ({
        ...list,
        fromHierarchyId: primaryHierarchyId,
      })),
    ];
    return el;
  } else return [];
};
